/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Complete_TitleInputs */

const en_us2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile complete`)
};

const pt_br2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil completo`)
};

const es_419_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil completo`)
};

const pt_pt2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfil completo`)
};

const fr_fr2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil complet`)
};

const de_de2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil vollständig`)
};

const it_it2_profile_complete_title = /** @type {(inputs: Profile_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilo completo`)
};

/**
* | output |
* | --- |
* | "Profile complete" |
*
* @param {Profile_Complete_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_complete_title = /** @type {((inputs?: Profile_Complete_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Complete_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_complete_title(inputs)
	if (locale === "es-419") return es_419_profile_complete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_complete_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_complete_title(inputs)
	if (locale === "de-DE") return de_de2_profile_complete_title(inputs)
	if (locale === "it-IT") return it_it2_profile_complete_title(inputs)
	return en_us2_profile_complete_title(inputs)
});
export { profile_complete_title as "profile.complete_title" }